import { EvidencesApi } from '../../generated/new';

const evidencesApi = new EvidencesApi();

export default evidencesApi;
